import { Form, Spin, Typography } from "antd/es";
import { connect } from "react-redux";
import {
  Button,
  Icon,
  KCol,
  KPagination,
  KRow,
  KTable,
  KTableColumn,
  KTableHeader,
  KTableRow,
  Label,
  TextInput,
} from "../../components/web-components";
import {
  hideImportMappedExcelModal,
  hideIyzicoDrawer,
  hidePhotoTake,
  hideStripeDrawer,
  showImportMappedExcelModal,
  showIyzicoDrawer,
  showPhotoTake,
  showStripeDrawer,
} from "../../redux/modals/actions";
import { AppState } from "../../redux/root-reducer";
import { KuikaTabOrderProvider } from "../../shared/hoc/tab-order-provider";
import { withContext } from "../../shared/hoc/with-context";
import { withForm } from "../../shared/hoc/with-form";
import { withGoogleLogin } from "../../shared/hoc/with-google-login";
import { withHistory } from "../../shared/hoc/with-history";
import { withScreenInput } from "../../shared/hoc/with-screen-input";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { CustomerSelect_ScreenBase } from "./customerselect-base";

declare let window: any;
const { Title, Paragraph, Text, Link } = Typography;
const menuMap = [];

class CustomerSelect_Screen extends CustomerSelect_ScreenBase {
  render() {
    if (this.state.isPageVisible === false) {
      return <></>;
    }
    return (
      <>
        <Spin
          spinning={
            this.state.spinnerCount > 0 ||
            (!!this.context?.callCallbackFunction &&
              !this.context?.isMasterPageInitLoaded &&
              !this.state.isPageInitLoaded)
          }
        >
          <KuikaTabOrderProvider>
            <Form
              form={this.props.form}
              name="basic"
              component={false}
              initialValues={{ customerselect_683957_value: undefined }}
              onValuesChange={(changedValues, allValues) => {
                this.clearFieldValidation(changedValues);
              }}
            >
              <>
                <div
                  key="-1"
                  id="customerselect_body"
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      backgroundColor: "rgba(244, 244, 244, 1)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "left",
                      display: "block",
                      overflow: "auto",
                      minHeight:
                        "calc(100vh - 92px - 0px - 0px - 0px - 0px - 0px)",
                      maxHeight:
                        "calc(100vh - 92px - 0px - 0px - 0px - 0px - 0px)",
                      height:
                        "calc(100vh - 92px - 0px - 0px - 0px - 0px - 0px)",
                    } as any
                  }
                >
                  <KRow
                    key="158211"
                    id="158211"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                      } as any
                    }
                  >
                    <KCol
                      key="471377"
                      id="471377"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                        } as any
                      }
                    >
                      <KRow
                        key="497061"
                        id="497061"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            borderBottomLeftRadius: 8,
                            borderTopWidth: 1,
                            borderRightWidth: 1,
                            borderBottomWidth: 1,
                            borderLeftWidth: 1,
                            borderColor: "rgba(218, 218, 218, 1)",
                            borderStyle: "solid",
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                          } as any
                        }
                      >
                        <KCol
                          key="970801"
                          id="970801"
                          xs={24}
                          sm={24}
                          md={24}
                          lg={24}
                          xl={24}
                          xxl={24}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "flex-start",
                              textAlign: "-webkit-left",
                            } as any
                          }
                        >
                          <KRow
                            key="152465"
                            id="152465"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <KCol
                              key="286681"
                              id="286681"
                              xs={24}
                              sm={2}
                              md={2}
                              lg={2}
                              xl={2}
                              xxl={2}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "center",
                                  textAlign: "-webkit-center",
                                } as any
                              }
                            >
                              <Button
                                key="734900"
                                id="734900"
                                label={ReactSystemFunctions.translate(
                                  this.ml,
                                  734900,
                                  "label",
                                  this.defaultML
                                )}
                                size="middle"
                                loading={false}
                                ghost={false}
                                block={false}
                                htmlType="button"
                                icon="person_add"
                                iconPosition="left"
                                danger={false}
                                iconLibrary="material"
                                style={
                                  {
                                    borderTopLeftRadius: 8,
                                    borderTopRightRadius: 8,
                                    borderBottomRightRadius: 8,
                                    borderBottomLeftRadius: 8,
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    backgroundColor: "rgba(0, 0, 0, 1)",
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "contain",
                                    backgroundPosition: "left",
                                    paddingTop: 8,
                                    paddingRight: 16,
                                    paddingBottom: 8,
                                    paddingLeft: 16,
                                    alignItems: "center",
                                    textAlign: "-webkit-center",
                                    display: "inline",
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                    fontSize: "24px",
                                    color: "rgba(255, 255, 255, 1)",
                                    lineHeight: "22px",
                                  } as any
                                }
                              ></Button>
                            </KCol>
                          </KRow>
                          <KRow
                            key="269775"
                            id="269775"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <KCol
                              key="636789"
                              id="636789"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderTopLeftRadius: 8,
                                  borderTopRightRadius: 8,
                                  borderBottomRightRadius: 8,
                                  borderBottomLeftRadius: 8,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(218, 218, 218, 1)",
                                  borderStyle: "solid",
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                } as any
                              }
                            >
                              <KRow
                                key="216637"
                                id="216637"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                  } as any
                                }
                              >
                                <KCol
                                  key="329005"
                                  id="329005"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 8,
                                      borderTopRightRadius: 8,
                                      borderBottomRightRadius: 8,
                                      borderBottomLeftRadius: 8,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      alignItems: "center",
                                      textAlign: "-webkit-center",
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="479340"
                                    id="479340"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderTopLeftRadius: 200,
                                        borderTopRightRadius: 200,
                                        borderBottomRightRadius: 200,
                                        borderBottomLeftRadius: 200,
                                        borderTopWidth: 1,
                                        borderRightWidth: 1,
                                        borderBottomWidth: 1,
                                        borderLeftWidth: 1,
                                        borderColor: "rgba(218, 218, 218, 1)",
                                        borderStyle: "solid",
                                        backgroundColor:
                                          "rgba(255, 255, 255, 1)",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                        backgroundPosition: "left",
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="254706"
                                      id="254706"
                                      xs={3}
                                      sm={3}
                                      md={3}
                                      lg={3}
                                      xl={3}
                                      xxl={3}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "center",
                                          textAlign: "-webkit-center",
                                        } as any
                                      }
                                    >
                                      <Icon
                                        key="583618"
                                        id="583618"
                                        iconName="search"
                                        iconLibrary="material"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            display: "inline",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "32px",
                                            color: "rgba(155, 155, 155, 1)",
                                            letterSpacing: "1px",
                                          } as any
                                        }
                                      ></Icon>
                                    </KCol>
                                    <KCol
                                      key="810674"
                                      id="810674"
                                      xs={21}
                                      sm={21}
                                      md={21}
                                      lg={21}
                                      xl={21}
                                      xxl={21}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <Form.Item
                                        className="kFormItem"
                                        name="customerselect_683957_value"
                                      >
                                        <TextInput
                                          key="683957"
                                          id="683957"
                                          onChange={(e?: any) => {
                                            if (e && e.stopPropagation)
                                              e.stopPropagation();
                                            this.CustomerSelectComponent_683957_onChange();
                                          }}
                                          kuikaRef={
                                            this
                                              .customerselect_683957_value_kuikaTextInputRef
                                          }
                                          placeholder={ReactSystemFunctions.translate(
                                            this.ml,
                                            683957,
                                            "placeholder",
                                            this.defaultML
                                          )}
                                          allowClear={true}
                                          bordered={true}
                                          disabled={false}
                                          type="text"
                                          iconColor="rgba(0, 0, 0, 1)"
                                          formatter="None"
                                          isCharOnly={false}
                                          autoComplete={true}
                                          inputMode="all"
                                          speechToText={false}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "16px",
                                              color: "rgba(74, 74, 74, 1)",
                                            } as any
                                          }
                                        ></TextInput>
                                      </Form.Item>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                            </KCol>
                          </KRow>
                        </KCol>
                      </KRow>
                      <KRow
                        key="485699"
                        id="485699"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                          } as any
                        }
                      >
                        <KCol
                          key="288289"
                          id="288289"
                          xs={24}
                          sm={24}
                          md={24}
                          lg={24}
                          xl={24}
                          xxl={24}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                            } as any
                          }
                        >
                          <Label
                            key="812770"
                            id="812770"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              812770,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "20px",
                                color: "rgba(0, 0, 0, 1)",
                              } as any
                            }
                          ></Label>
                        </KCol>
                      </KRow>
                      <KRow
                        key="817345"
                        id="817345"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                          } as any
                        }
                      >
                        <KCol
                          key="320193"
                          id="320193"
                          xs={24}
                          sm={24}
                          md={24}
                          lg={24}
                          xl={24}
                          xxl={24}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "flex-start",
                              textAlign: "-webkit-left",
                            } as any
                          }
                        >
                          <KTable
                            key="13255"
                            id="13255"
                            kuikaRef={
                              this.customerselect_13255_value_kuikaTableRef
                            }
                            form={this.props.form}
                            dataSource={this.state.GetRetailCustomers}
                            size="middle"
                            bordered={true}
                            loading={false}
                            rowKey="id"
                            transformedOnMobileResolution={false}
                            hideHeaderOnMobileResolution={false}
                            showHeader={false}
                            fixedHeader={false}
                            tableWidthMode="fit"
                            editable={false}
                            editableAlwaysActive={false}
                            insertRowActive={false}
                            insertRowPosition="top"
                            globalSearch={false}
                            searchable={false}
                            shouldSearchOnChange={true}
                            searchDelay={200}
                            sorter={false}
                            filtering={false}
                            resizableColumns={false}
                            pagination={false}
                            pageSize={10}
                            showSizeChanger={false}
                            paginationSelectedTextColor="#246eff"
                            paginationUnselectedTextColor="#000"
                            columnChooser={false}
                            striped={false}
                            stripedColor="#F5F7FA"
                            rowHoverBgColor="#fafafa"
                            showRowNumbers={false}
                            showNoDataFound={true}
                            nodatafoundmessage={ReactSystemFunctions.translate(
                              this.ml,
                              13255,
                              "nodatafoundmessage",
                              this.defaultML
                            )}
                            multiSelect={false}
                            multiSelectScope="page"
                            export={false}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <KTableHeader
                              key="946630"
                              id="946630"
                              hideOnMobileResolution={false}
                              textDirection="Default"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  color: "rgba(155, 155, 155, 1)",
                                  lineHeight: "20px",
                                } as any
                              }
                            ></KTableHeader>
                            <KTableRow
                              key="682180"
                              id="682180"
                              hoverFontColor="red"
                              hoverBgColor="#F5F5F5"
                              style={
                                {
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <KTableColumn
                                key="820957"
                                id="820957"
                                title={ReactSystemFunctions.translate(
                                  this.ml,
                                  820957,
                                  "title",
                                  this.defaultML
                                )}
                                alwaysVisibleOnMobileResolution={false}
                                hideFiltering={false}
                                hideSorting={false}
                                hideSearch={false}
                                footerOptions="none"
                                footerFontSize={14}
                                footerFontColor="rgb(68, 68, 68)"
                                excludeFromExport={false}
                                footerFontWeight="Regular"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <KRow
                                  key="296314"
                                  id="296314"
                                  align="top"
                                  justify="start"
                                  horizontalGutter={0}
                                  verticalGutter={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 8,
                                      borderTopRightRadius: 8,
                                      borderBottomRightRadius: 8,
                                      borderBottomLeftRadius: 8,
                                      borderTopWidth: 1,
                                      borderRightWidth: 1,
                                      borderBottomWidth: 1,
                                      borderLeftWidth: 1,
                                      borderColor: "rgba(140, 140, 140, 0.2)",
                                      borderStyle: "solid",
                                      backgroundColor: "rgba(255, 255, 255, 1)",
                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain",
                                      backgroundPosition: "left",
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KCol
                                    key="723255"
                                    id="723255"
                                    xs={24}
                                    sm={2}
                                    md={2}
                                    lg={2}
                                    xl={2}
                                    xxl={2}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <Icon
                                      key="455540"
                                      id="455540"
                                      iconName="person"
                                      iconLibrary="material"
                                      style={
                                        {
                                          borderTopLeftRadius: 8,
                                          borderTopRightRadius: 8,
                                          borderBottomRightRadius: 8,
                                          borderBottomLeftRadius: 8,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          backgroundColor:
                                            "rgba(68, 142, 247, 0.2)",
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "32px",
                                          color: "rgba(68, 142, 247, 1)",
                                          letterSpacing: "1px",
                                        } as any
                                      }
                                    ></Icon>
                                  </KCol>
                                  <KCol
                                    key="327297"
                                    id="327297"
                                    xs={24}
                                    sm={22}
                                    md={22}
                                    lg={22}
                                    xl={22}
                                    xxl={22}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KRow
                                      key="22516"
                                      id="22516"
                                      align="top"
                                      justify="start"
                                      horizontalGutter={0}
                                      verticalGutter={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="452394"
                                        id="452394"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={24}
                                        xxl={24}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="389797"
                                          id="389797"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="344590"
                                            id="344590"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={24}
                                            xxl={24}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                              } as any
                                            }
                                          >
                                            <KRow
                                              key="11392"
                                              id="11392"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="674322"
                                                id="674322"
                                                xs={24}
                                                sm={24}
                                                md={24}
                                                lg={24}
                                                xl={24}
                                                xxl={24}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="117289"
                                                  id="117289"
                                                  value="[datafield:customerName]"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "16px",
                                                      color:
                                                        "rgba(74, 74, 74, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </KCol>
                                            </KRow>
                                            <KRow
                                              key="351375"
                                              id="351375"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="761521"
                                                id="761521"
                                                xs={24}
                                                sm={24}
                                                md={24}
                                                lg={24}
                                                xl={24}
                                                xxl={24}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="197347"
                                                  id="197347"
                                                  value="[datafield:identityNum]"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(155, 155, 155, 1)",
                                                      lineHeight: "20px",
                                                    } as any
                                                  }
                                                ></Label>
                                              </KCol>
                                            </KRow>
                                            <KRow
                                              key="491446"
                                              id="491446"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="465728"
                                                id="465728"
                                                xs={24}
                                                sm={24}
                                                md={24}
                                                lg={24}
                                                xl={24}
                                                xxl={24}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="716590"
                                                  id="716590"
                                                  value="[datafield:customerMail]"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(155, 155, 155, 1)",
                                                      lineHeight: "20px",
                                                    } as any
                                                  }
                                                ></Label>
                                              </KCol>
                                            </KRow>
                                            <KRow
                                              key="270386"
                                              id="270386"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="752616"
                                                id="752616"
                                                xs={24}
                                                sm={24}
                                                md={24}
                                                lg={24}
                                                xl={24}
                                                xxl={24}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="589810"
                                                  id="589810"
                                                  value="[datafield:customerPhone]"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(155, 155, 155, 1)",
                                                      lineHeight: "20px",
                                                    } as any
                                                  }
                                                ></Label>
                                              </KCol>
                                            </KRow>
                                          </KCol>
                                        </KRow>
                                        <KRow
                                          key="609118"
                                          id="609118"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="325988"
                                            id="325988"
                                            xs={24}
                                            sm={19}
                                            md={19}
                                            lg={19}
                                            xl={19}
                                            xxl={19}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                              } as any
                                            }
                                          >
                                            <Button
                                              key="161920"
                                              id="161920"
                                              onClick={(e?: any) => {
                                                if (e && e.stopPropagation)
                                                  e.stopPropagation();
                                                this.CustomerSelectComponent_161920_onClick();
                                              }}
                                              showCursorPointer
                                              label={ReactSystemFunctions.translate(
                                                this.ml,
                                                161920,
                                                "label",
                                                this.defaultML
                                              )}
                                              size="middle"
                                              loading={false}
                                              ghost={false}
                                              block={false}
                                              htmlType="button"
                                              iconLibrary="material"
                                              iconPosition="left"
                                              danger={false}
                                              style={
                                                {
                                                  borderTopLeftRadius: 8,
                                                  borderTopRightRadius: 8,
                                                  borderBottomRightRadius: 8,
                                                  borderBottomLeftRadius: 8,
                                                  borderTopWidth: 2,
                                                  borderRightWidth: 2,
                                                  borderBottomWidth: 2,
                                                  borderLeftWidth: 2,
                                                  borderColor: "transparent",
                                                  borderStyle: "solid",
                                                  backgroundColor:
                                                    "rgba(0, 0, 0, 1)",
                                                  backgroundRepeat: "no-repeat",
                                                  backgroundSize: "contain",
                                                  backgroundPosition: "left",
                                                  paddingTop: 8,
                                                  paddingRight: 16,
                                                  paddingBottom: 8,
                                                  paddingLeft: 16,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-center",
                                                  display: "block",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "16px",
                                                  color:
                                                    "rgba(255, 255, 255, 1)",
                                                } as any
                                              }
                                            ></Button>
                                          </KCol>
                                          <KCol
                                            key="222073"
                                            id="222073"
                                            xs={24}
                                            sm={5}
                                            md={5}
                                            lg={5}
                                            xl={5}
                                            xxl={5}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "center",
                                                textAlign: "-webkit-center",
                                              } as any
                                            }
                                          >
                                            <Button
                                              key="602236"
                                              id="602236"
                                              onClick={(e?: any) => {
                                                if (e && e.stopPropagation)
                                                  e.stopPropagation();
                                                this.CustomerSelectComponent_602236_onClick();
                                              }}
                                              showCursorPointer
                                              label={ReactSystemFunctions.translate(
                                                this.ml,
                                                602236,
                                                "label",
                                                this.defaultML
                                              )}
                                              size="middle"
                                              loading={false}
                                              ghost={false}
                                              block={false}
                                              htmlType="button"
                                              icon="keyboard_arrow_right"
                                              iconPosition="right"
                                              danger={false}
                                              iconLibrary="material"
                                              style={
                                                {
                                                  borderTopLeftRadius: 8,
                                                  borderTopRightRadius: 8,
                                                  borderBottomRightRadius: 8,
                                                  borderBottomLeftRadius: 8,
                                                  borderTopWidth: 2,
                                                  borderRightWidth: 2,
                                                  borderBottomWidth: 2,
                                                  borderLeftWidth: 2,
                                                  borderColor:
                                                    "rgba(0, 0, 0, 0.2)",
                                                  borderStyle: "solid",
                                                  backgroundColor:
                                                    "rgba(244, 244, 244, 1)",
                                                  backgroundRepeat: "no-repeat",
                                                  backgroundSize: "contain",
                                                  backgroundPosition: "left",
                                                  paddingTop: 8,
                                                  paddingRight: 16,
                                                  paddingBottom: 8,
                                                  paddingLeft: 16,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-center",
                                                  display: "block",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "16px",
                                                  color: "rgba(0, 0, 0, 1)",
                                                } as any
                                              }
                                            ></Button>
                                          </KCol>
                                        </KRow>
                                      </KCol>
                                    </KRow>
                                  </KCol>
                                </KRow>
                              </KTableColumn>
                            </KTableRow>
                          </KTable>
                          <KPagination
                            key="235038"
                            id="235038"
                            onChange={(e?: any) => {
                              if (e && e.stopPropagation) e.stopPropagation();
                              this.CustomerSelectComponent_235038_onChange();
                            }}
                            kuikaRef={
                              this
                                .customerselect_235038_value_kuikaPaginationRef
                            }
                            total={
                              this.state.GetRetailCustomers?.at?.(0)
                                ?.totalRowCount ?? undefined
                            }
                            pageSize={10}
                            defaultCurrent={1}
                            current={1}
                            defaultPageSize={10}
                            disabled={false}
                            hideOnSinglePage={true}
                            showLessItems={false}
                            showQuickJumper={false}
                            showSizeChanger={false}
                            showFirstPageButton={false}
                            showLastPageButton={false}
                            showNumbers={true}
                            showText={false}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-right",
                              } as any
                            }
                          ></KPagination>
                        </KCol>
                      </KRow>
                    </KCol>
                  </KRow>
                </div>
              </>
            </Form>
          </KuikaTabOrderProvider>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    spinnerCount: state.spinnerReducer.spinnerCount,
    photoTakeVisible: state.photoTakeReducer.visible,
    isImportMappedExcelModalVisible:
      state.importMappedExcelModalReducer.visible,
  };
};
const mapDispatchToProps = (dispatch) => ({
  showPhotoTake: () => dispatch(showPhotoTake()),
  hidePhotoTake: () => dispatch(hidePhotoTake()),
  showStripeDrawer: (data, callback, that, future) =>
    dispatch(showStripeDrawer(data, callback, that, future)),
  hideStripeDrawer: (data, callback, that) =>
    dispatch(hideStripeDrawer(data, callback, that)),
  showIyzicoDrawer: (data, callback, that) =>
    dispatch(showIyzicoDrawer(data, callback, that)),
  hideIyzicoDrawer: (data, callback, that) =>
    dispatch(hideIyzicoDrawer(data, callback, that)),
  showImportMappedExcelModal: (
    dsId,
    tableName,
    primaryKey,
    columnMapping,
    parameters
  ) =>
    dispatch(
      showImportMappedExcelModal(
        dsId,
        tableName,
        primaryKey,
        columnMapping,
        parameters
      )
    ),
  hideImportMappedExcelModal: () => dispatch(hideImportMappedExcelModal()),
});
const tmp = withGoogleLogin(
  withContext(
    withScreenInput(
      withForm(
        withHistory(
          connect(mapStateToProps, mapDispatchToProps)(CustomerSelect_Screen)
        )
      )
    )
  )
);
export { tmp as CustomerSelect_Screen };
//export default tmp;
//export { tmp as CustomerSelect_Screen };
